import React from "react";


export const Services = (props) => {
  return (
    <div id="services" className="text-center" style={{background:"black"}}>
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
           Creative media and production services that bring stories, ideas, and culture to life.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  {" "}
                  <i style={{background:"#d38a3bff"}} className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
